import React from 'react';
import type { FooterMoreProps } from './types';
import {
  bridge,
  convertDeeplinkToWebLink,
  getWebBaseURL,
  isNil,
} from '../../../../utils';
import { ABLY_INFO } from '../../../../constant/ablyInfo';
import type { IScreensLogging } from '../../../../api/types';
import { Flex, PrimaryButton } from '@banhala/ui-kit';

export const FooterMore: React.FC<FooterMoreProps> = ({ footer }) => {
  if (isNil(footer)) return null;

  const handleClickViewAllButton = () => {
    const { deeplink } = footer.item;
    if (deeplink === null) {
      return;
    }

    logClickViewAllButton({ logging: footer.logging });

    bridge.openDeeplink(deeplink, {
      webCallback: async () => {
        const baseURL = await getWebBaseURL();
        const convertedLink = convertDeeplinkToWebLink(deeplink);
        if (convertedLink === ABLY_INFO.url) {
          location.href = ABLY_INFO.url;
          return;
        }
        location.href = `${baseURL}${convertedLink}`;
      },
    });
  };

  return (
    <Flex
      padding={{ horizontal: 16, top: 16, bottom: 24 }}
      margin={{ top: footer.item.margin_top }}
    >
      <PrimaryButton
        color="gray"
        size="large"
        variant={'fill'}
        outline
        onPress={handleClickViewAllButton}
      >
        {footer.item.title}
      </PrimaryButton>
    </Flex>
  );
};

const logClickViewAllButton = ({ logging }: { logging: IScreensLogging }) => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_FOOTER_SMALL_ONE_LINE_MORE',
    analytics: logging.analytics,
    ably_only_log: logging.ably_only_log,
  });
};
